import { CommonModule } from '@angular/common';
import { Component, OnDestroy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { TranslocoModule } from '@jsverse/transloco';
import { AuthService } from '../../core/auth/auth.service';

@Component({
  selector: 'app-reset-password',
  standalone: true,
  imports: [CommonModule, TranslocoModule, ReactiveFormsModule],
  templateUrl: './reset-password.component.html',
  styleUrl: './reset-password.component.scss',
})
export class ResetPasswordComponent implements OnDestroy {
  public resetPasswordGroup: FormGroup = new FormGroup({
    password: new FormControl('', [Validators.required, Validators.minLength(8)]),
    passwordConfirm: new FormControl('', [Validators.required, Validators.minLength(8)]),
  });

  public code: string = '';

  private _unsubscribeAll: Subject<any> = new Subject<any>();

  constructor(private fb: FormBuilder, private authService: AuthService, private router: Router, private route: ActivatedRoute) {
    this.route.queryParams.pipe(takeUntil(this._unsubscribeAll)).subscribe(params => {
      this.code = params['code'];
    });
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

  public onClickSubmit(): void {
    // this.authServie.resetPassword(this.resetPasswordGroup.value.password, this.code).then((res: any) => {
    //   if (res.data.passwordReset.error) {
    //     this.router.navigate(['/forgot-password'], { queryParams: { redirectUrl: this.authServie.redirectUrl } });
    //     return;
    //   }
    //   this.router.navigate(['/'], { queryParams: { redirectUrl: this.authServie.redirectUrl } });
    // });
  }
}
